import soundLike from "../assets/audio/message-like.mp3";

export const sounds = {
  MESSAGE_LIKE: soundLike,
};
